module.exports = __webpack_public_path__ + "static/media/step3.770c99e6.png";